module.exports = __webpack_public_path__ + "static/img/top-icon.18d5144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/top-icon.png
// module id = E4GD
// module chunks = 1